import { Input, InputProps, TextField } from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { UpdateWorkerCollection } from "../../../queries/WorkerCollectionData";

const CustomInput = ({ value, onChange, inputRef }) => {
  const inputStyle = { border: "none", outline: "none", background: "none" };

  return (
    <TextField
      InputProps={{ disableUnderline: true, style: inputStyle }}
      placeholder="Enter value"
      value={value}
      onChange={onChange}
      ref={inputRef}
      type="number"
      variant="standard"
      inputProps={{
        min: -1,
      }}
    />
  );
};

const MultilineEditor = (props) => {
  const [values, setValues] = useState(props?.data?.queueArr);
  const inputRefs = useRef([]); // create a ref for each input
  const handleInputChange = (event, index) => {
    const newValues = [...values];
    const inputValue = event.target.value.length == 0 ? 0 : event.target.value;
    if (!isNaN(inputValue) && Number(inputValue) >= 0) {
      newValues[index].max_cases = inputValue;
      setValues(newValues);
    } else {
      console.warn("Please enter a valid number greater than 0.");
    }
  };

  const handleKeyDown = useCallback((event, index) => {
    if (event.key === "Enter") {
      const requestBody = {
        max_cases: values[index]?.max_cases,
      };
      props?.client
        .mutate({
          mutation: UpdateWorkerCollection,
          variables: {
            id: values[index]?.workerCollectionId,
            collection: requestBody,
          },
          // fetchPolicy: "cache-first",
        })
        .then((response: any) => {
          // setSelectOptions(response?.data?.QueryProfile);
        })
        .catch((err) => console.error(err));
    }
  }, []);

  useEffect(() => {
    inputRefs.current.forEach((ref, index) => {
      ref.removeEventListener("keydown", handleKeyDown);
      ref.addEventListener("keydown", (event) => handleKeyDown(event, index));
    });
  }, [handleKeyDown]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        paddingLeft: "32px",
      }}
    >
      {values.map((value, index) => (
        <CustomInput
          key={index}
          value={value?.max_cases}
          onChange={(event) => handleInputChange(event, index)}
          inputRef={(ref) => (inputRefs.current[index] = ref)}
        />
      ))}
    </div>
  );
};

export default MultilineEditor;
